import { render, staticRenderFns } from "./PersonalDetailsStepComponent.vue?vue&type=template&id=4889b419"
import script from "./PersonalDetailsStepComponent.vue?vue&type=script&lang=ts"
export * from "./PersonalDetailsStepComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports